import { AUTH_LAYOUT_MARK_LOGO_SRC } from 'common/constants/auth';
import { Text } from 'components/ui';
import { AUTH_FORM_HEADER_FIRM_LOGO_ALT, AUTH_FORM_HEADER_MARK_ALT } from './AuthFormHeader.constants';
import { AuthFormHeaderProps } from './AuthFormHeader.props';
import {
  AuthFormHeaderBrandLink,
  AuthFormHeaderBrandLockup,
  AuthFormHeaderFirmIcon,
  AuthFormHeaderFirmImage,
  AuthFormHeaderFirmLogo,
  AuthFormHeaderFirmName,
  AuthFormHeaderMarkLogo,
  AuthFormHeaderPlus,
  AuthFormHeaderRoot,
  AuthFormHeaderSubtitle,
  AuthFormHeaderTitle,
} from './AuthFormHeader.styles';

const AuthFormHeader = ({
  firmName,
  iconUrl,
  logoAlt = AUTH_FORM_HEADER_FIRM_LOGO_ALT,
  logoUrl,
  subtitle,
  subtitleVariant = 'default',
  title,
}: AuthFormHeaderProps) => {
  let firmBranding = null;

  if (logoUrl) {
    firmBranding = <AuthFormHeaderFirmImage alt={logoAlt} src={logoUrl} />;
  } else if (iconUrl) {
    firmBranding = <AuthFormHeaderFirmIcon alt={logoAlt} src={iconUrl} />;
  } else if (firmName) {
    firmBranding = <AuthFormHeaderFirmName>{firmName}</AuthFormHeaderFirmName>;
  }

  const hasCobranding = Boolean(firmBranding);
  const isTextBranding = Boolean(firmName) && !logoUrl && !iconUrl;

  return (
    <AuthFormHeaderRoot data-auth-header-root="true">
      <AuthFormHeaderBrandLockup hasCobranding={hasCobranding} isTextBranding={isTextBranding}>
        <AuthFormHeaderBrandLink to="/">
          <AuthFormHeaderMarkLogo alt={AUTH_FORM_HEADER_MARK_ALT} src={AUTH_LAYOUT_MARK_LOGO_SRC} />
        </AuthFormHeaderBrandLink>
        {firmBranding ? (
          <>
            <AuthFormHeaderPlus aria-hidden="true">+</AuthFormHeaderPlus>
            <AuthFormHeaderFirmLogo isTextBranding={isTextBranding}>{firmBranding}</AuthFormHeaderFirmLogo>
          </>
        ) : null}
      </AuthFormHeaderBrandLockup>
      {title ? (
        <AuthFormHeaderTitle>
          <Text component="h1" visualVariant="displayTitle">
            {title}
          </Text>
        </AuthFormHeaderTitle>
      ) : null}
      {subtitle ? <AuthFormHeaderSubtitle subtitleVariant={subtitleVariant}>{subtitle}</AuthFormHeaderSubtitle> : null}
    </AuthFormHeaderRoot>
  );
};

export default AuthFormHeader;
